import { styled } from "styled-components";
import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { API_BASE } from "../../shared/Constants";
import { copyToClipboard } from "../../utils/clipboard";


export default function Snippet() {
  const [copied, setCopied] = useState(false);

  const snippet = `curl "${API_BASE}/api/chat/completions" \\
    -H "Content-Type: application/json" \\
    -H "Authorization: Bearer <API_KEY>" \\
    -d '{
        "model": "sabia-4",
        "messages": [
            {
                "role": "user",
                "content": "Olá, Mundo!"
            }
        ]
    }'`;

  const handleCopy = async () => {
    const ok = await copyToClipboard(snippet);
    if (ok) setCopied(true);
  };

  useEffect(() => {
    if (!copied) return;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);

  return (
    <>
      <CodeContainer>
        <CopyButton onClick={handleCopy} aria-label="Copiar">
          {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </CopyButton>
        <CodeBlock>{snippet}</CodeBlock>
      </CodeContainer>
    </>
  );
}

const CodeContainer = styled.div`
  position: relative;
`;

const CodeBlock = styled.pre`
  background: hsl(var(--code));
  color: #e8f2ed;
  border-radius: 8px;
  margin: 0;
  padding: 18px 52px 18px 18px;
  font-family: "Source Code Pro", monospace;
  font-size: 0.78rem;
  line-height: 1.65;
  user-select: all;
  overflow-x: auto;
`;

const CopyButton = styled(IconButton)`
  && {
    position: absolute;
    top: 12px;
    right: 10px;
    color: #b9c9c1;
    border-radius: 6px;
    padding: 4px;
  }
`;
